<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: 'text',
    },
    isPrice: {
      default: false,
      type: Boolean,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
      default: 50,
    },
    id: {
      type: String,
    },
    classes: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    limit: {
      type: Number,
    },
    noAddOnEnter: {
      type: Boolean,
    },
    showError: {
      type: Boolean,
      required: false,
    },
    isRequired: {
      type: Boolean,
      required: false,
    },
    errorText: {
      type: String,
      default: 'وارد کردن این فیلد الزامی است',
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    enterClicked() {
      this.$emit('enterButton')
    },
  },
}
</script>

<template>
  <div class="mainInput" :class="classes">
    <span class="labelStyle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</span>
    <div style="width: 100%">
      <b-form-tags
        :placeholder="disable ? '' : placeholder"
        input-id="tags-basic"
        :disabled="disable"
        v-model="inputVal"
        :limit="limit"
        :class="{ __show_error: showError, __is_required: isRequired }"
        :no-add-on-enter="noAddOnEnter"
      >
      </b-form-tags>

      <label v-if="showError" class="__label_error">{{ errorText }}</label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .badge {
  color: #5a5c5f;
  background: #ced4da;
  padding: 7px;
  margin-left: 5px;
}
::v-deep .form-control {
  line-height: 27px;
  padding: 2px;
}
.mainInput {
  display: flex;
  align-items: center;
}
input {
  width: 100%;
  color: #5a5c5f;
  background: #ced4da;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}
input:disabled {
  color: transparent !important;
}
.labelStyle {
  min-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.__show_error {
  border: 1px solid rgb(254, 94, 97);
}

.__label_error {
  display: block;
  margin: 5px 0 0;

  font-size: 10px;
  color: rgb(246, 98, 101);
}

.__is_required {
  border-right: 4px solid rgb(254, 94, 97);
}
</style>
